/* eslint-disable import/no-named-as-default */
import React from 'react';
import { SecureRoute, LoginCallback, PrimeAuthLoginCallback } from '@skyslope/auth-react';
import { Redirect, Route, Switch } from 'react-router';
import { isWidgetTokenSession } from './auth/widget-token';
import NotFound from './common/errorPages/NotFound';
import { SubscriptionPage } from './components/pageFrame/SubscriptionPage';
import Login from './components/senderBuild/Login';
import TemplateShare from './components/templateSharing/TemplateShare';
import { ApplyTemplate } from './containers/ApplyTemplate';
import { CouponRedirect } from './containers/CouponRedirect';
import { EnvelopeBuilderPage } from './containers/envelope-template-builder/envelope-builder-page';
import { TemplateBuilderPage } from './containers/envelope-template-builder/template-builder-page';
import EnvelopeDocuments from './containers/EnvelopeDocuments';
import EnvelopeHistory from './containers/EnvelopeHistory';
import EnvelopeManagement from './containers/EnvelopeManagement';
import LoggedOut from './containers/LoggedOut';
import Logout from './containers/Logout';
import RecipientManagement from './containers/recipient-management/recipient-management';
import TemplateCreate from './containers/TemplateCreate';
import { TemplateManagement } from './containers/TemplateManagement';
import TemplateTagging from './containers/TemplateTagging';
import UserPreferences from './containers/UserPreferences';
import Documents from './dtm/containers/Documents';
import Properties from './dtm/containers/Properties';
import Recipients from './dtm/containers/Recipients';

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function App() {
  return (
    <Switch>
      <Redirect from="/envelope/:id" to="/envelopes/:id" exact />
      <Route path="/" component={Login} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/envelopes" component={EnvelopeManagement} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/envelopes/:id/history" component={EnvelopeHistory} exact />

      <SecureRoute
        // @ts-expect-error -- SecureRoute prop types are wrong
        path="/envelopes/:id"
        render={(props: any) => <EnvelopeBuilderPage {...props} />}
        exact
      />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/envelopes/:id/recipients" component={RecipientManagement} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/envelopes/:id/apply-template" component={ApplyTemplate} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/envelopes/:id/documents" component={EnvelopeDocuments} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/subscriptions" component={SubscriptionPage} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/dtm/properties" component={Properties} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/dtm/envelopes/:id/properties" component={Properties} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/dtm/envelopes/:id/documents" component={Documents} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/dtm/envelopes/:id/recipients" component={Recipients} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/preferences" component={UserPreferences} exact />
      <Route path="/auth/callback" component={LoginCallback} exact />
      <Route path="/auth/callback/prime" component={PrimeAuthLoginCallback} exact />
      {/* In a widget token session /logout loads with no session, so SecureRoute would ask the
          widget for a token instead of signing out. */}
      {isWidgetTokenSession() ? (
        <Route path="/logout" component={Logout} exact />
      ) : (
        // @ts-expect-error -- SecureRoute prop types are wrong
        <SecureRoute path="/logout" component={Logout} exact />
      )}
      <Route path="/logged_out" component={LoggedOut} exact />

      {/* Templates */}
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/templates/:id/info" component={TemplateTagging} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/templates/:id/create" component={TemplateCreate} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/templates/:id/share" render={(props) => <TemplateShare {...props} />} exact />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/templates" component={TemplateManagement} exact />
      <Route path="/templates/auth/callback" component={LoginCallback} />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/templates/logout" component={Logout} exact />
      <Route path="/templates/logged_out" component={LoggedOut} exact />
      <SecureRoute
        // @ts-expect-error -- SecureRoute prop types are wrong
        path="/templates/:id"
        render={(props: any) => <TemplateBuilderPage {...props} />}
        exact
      />
      {/* @ts-expect-error -- SecureRoute prop types are wrong */}
      <SecureRoute path="/coupon-redirect" component={CouponRedirect} />

      <Route path="*" component={NotFound} />
    </Switch>
  );
}
